import React from 'react';
import { Stack, Text } from '@chakra-ui/react';

import BorderedBox from '../BorderedBox';

const PersonalDetail: React.FC<{
  title: string;
  list: { label: string; value: any }[];
}> = ({ title, list }) => {
  return (
    <BorderedBox title={title}>
      <Stack gap={0}>
        {list.map((item, index) => {
          return (
            <Stack
              key={item.label}
              alignItems={{ base: 'flex-start', md: 'center' }}
              justifyContent="flex-start"
              flexDir={{ base: 'column', md: 'row' }}
              py={3}
              gap={{ base: 1, md: 0 }}
              borderBottomWidth={index < list.length - 1 ? '1px' : 0}
              borderBottomColor="rgba(255,255,255,0.06)"
            >
              <Text
                fontSize="sm"
                fontWeight="medium"
                color="body2"
                pr={{ md: 3 }}
                minW={{ md: '140px' }}
              >
                {item.label}
              </Text>
              <Text fontSize="sm" color="body" wordBreak="break-word">
                {item.value}
              </Text>
            </Stack>
          );
        })}
      </Stack>
    </BorderedBox>
  );
};

export default PersonalDetail;
